import { TFunction } from "i18next";
import {
  FieldType,
  FieldTypeType,
  getUnitDisplayName,
  OptionType,
  Unit,
} from "../../../services/helpers/types";

export const getOptions = (t: TFunction): OptionType[] => {
  const OPTIONS: OptionType[] = [
    {
      name: "Žiadna",
      value: "",
      position: 1,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.PerMinute],
      value: Unit.PerMinute,
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.Day],
      value: Unit.Day,
      position: 3,
      optionID: 2,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.SizeCM],
      value: Unit.SizeCM,
      position: 4,
      optionID: 3,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.Weight],
      value: Unit.Weight,
      position: 5,
      optionID: 4,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.Percent],
      value: Unit.Percent,
      position: 6,
      optionID: 5,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.Month],
      value: Unit.Month,
      position: 7,
      optionID: 6,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.PerDay],
      value: Unit.PerDay,
      position: 8,
      optionID: 7,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.Hours],
      value: Unit.Hours,
      position: 9,
      optionID: 8,
      fieldID: 4,
    },
  ];
  return OPTIONS;
};

export const getAddNumberUnitField = (t: TFunction): FieldType => {
  const ADD_NUMBER_UNIT_FIELD: FieldType = {
    fieldID: 5,
    name: "SelectField",
    position: 0,
    type: FieldTypeType.Select,
    noteOption: false,
    defaultValue: "",
    options: getOptions(t),
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return ADD_NUMBER_UNIT_FIELD;
};
